import { useModalStore } from './stores/useModalStore'
import { ActionConfig } from '../stores/Workflows/Types'
import { FunctionComponent, PropsWithChildren, useCallback } from 'react'

export interface PromptProps<Config extends ActionConfig> {
  onCancel: () => void
  onClose: () => void
  onConfirm: (config: Config) => void
}

export type ModalPromptProps<Config extends ActionConfig, Props> = PromptProps<Config> & Props & Config

type ModalType<Config extends ActionConfig, Props> = FunctionComponent<
  PropsWithChildren<ModalPromptProps<Config, Props>>
>

export const useActionModalPrompt = () => {
  const { openModal, closeModal } = useModalStore()
  return useCallback(
    <Config extends ActionConfig, Props>(Modal: ModalType<Config, Props>, props: Config & Props) =>
      new Promise<Config | null>((resolve) => {
        const modalProps = {
          onCancel: () => {
            resolve(null)
            closeModal()
          },
          onClose: () => {
            resolve(null)
            closeModal()
          },
          onConfirm: (config: Config) => {
            resolve(config)
          },
          children: undefined,
          ...props,
        }
        openModal(Modal, { customModal: true, modalProps })
      }),
    [openModal, closeModal],
  )
}
